/* eslint-disable react/prop-types */
import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {makeSelectIsAuthenticated} from 'reducers/selectors/userSelectors';

const isAuthenticatedSelector = makeSelectIsAuthenticated();

export default function PrivateRoute({component: Component, ...rest}) {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  return (
    <Route
      {...rest}
      render={(props) =>
        // <Component {...props} />
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {from: props.location},
            }}
          />
        )
      }
    />
  );
}
